var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 56,
    viewBox: "0 0 55 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.9113 31.0902C1.30075 31.0902 1 25.8966 1 24.8906",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1464 30.0983C51.2773 29.5383 50.6178 28.6796 50.3896 27.6716C50.1303 26.5287 49.7383 25.4253 49.2322 24.3675C48.7282 23.3117 48.722 22.088 49.1824 21.0136L52.8537 12.4453C48.498 12.4453 45.2478 13.5425 42.9372 14.8161C41.813 15.4362 40.4607 15.4611 39.2992 14.9156C35.9619 13.3455 32.0915 12.4453 27.964 12.4453C15.3636 12.4453 5.14844 20.802 5.14844 31.1126C5.14844 35.238 6.8036 39.0379 9.57258 42.1263L14.2228 52.9761C14.9425 54.6541 16.5085 55.9193 18.3338 55.996C21.2189 56.1205 23.4735 53.6004 23.069 50.7754L23.0483 50.6302C22.9549 49.9748 23.515 49.4169 24.1725 49.5081C25.4045 49.6824 26.6697 49.7798 27.964 49.7798C29.2582 49.7798 30.5256 49.6824 31.7576 49.5081C32.4379 49.4127 32.9668 49.9831 32.8735 50.6634C32.5935 52.7313 33.6409 54.849 35.574 55.6372C38.0464 56.6473 40.6391 55.4547 41.5952 53.225L44.2833 46.9549C44.8039 45.7394 45.8742 44.8455 47.1622 44.5468L51.5905 43.5222L53.8804 31.2163L52.1464 30.0983Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6427 37.6006C54.0039 41.0333 52.4898 43.6986 51.264 43.5534C50.0381 43.4082 49.5632 40.5044 50.202 37.0717C50.8408 33.639 52.355 30.9738 53.5808 31.1189C54.8066 31.2641 55.2816 34.1659 54.6427 37.6006Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9645 8.29656C30.0863 8.29656 32.1418 8.52679 34.1246 8.92088C34.1392 8.71139 34.1869 8.5102 34.1869 8.29656C34.1869 3.71479 30.4721 0 25.8903 0C21.3085 0 17.5938 3.71479 17.5938 8.29656C17.5938 8.88147 17.658 9.44979 17.7721 10.0015C20.9207 8.90843 24.3575 8.29656 27.9645 8.29656Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/Save.ee321d29ee3f860279d219adc1dfa972.svg";
export { ForwardRef as ReactComponent };